import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ThemeProvider } from './contexts/ThemeContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import PortfolioPage from './pages/PortfolioPage';
import ContactPage from './pages/ContactPage';

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

function App() {
  useEffect(() => {
    try {
      // Global GSAP settings
      gsap.config({
        nullTargetWarn: false,
        trialWarn: false,
        force3D: false
      });

      // Set default ease
      gsap.defaults({
        ease: "power2.out",
        duration: 1
      });

      return () => {
        // Cleanup ScrollTrigger instances
        try {
          ScrollTrigger.getAll().forEach(trigger => trigger.kill());
        } catch (error) {
          console.warn('Error cleaning up ScrollTrigger:', error);
        }
      };
    } catch (error) {
      console.error('Error initializing GSAP:', error);
    }
  }, []);

  return (
    <ThemeProvider>
      <Router>
        <div className="App bg-white dark:bg-gray-900 transition-colors duration-300 min-h-screen">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
